import React, { useEffect, useState, useContext, useMemo } from "react";
import { Form, useNavigate } from "react-router-dom";
// import TextField from "../../components/common/TextField.jsx";
import TextField from "../../components/newCommon/TextField/TextField.jsx";
import TextArea from "../../components/newCommon/TextArea/TextArea.jsx";
import NumberInput from "../../components/common/Number.jsx";
import Password from "../../components/common/Password.jsx";
import RadioSelector from "../../components/common/RadioSelector.jsx";
import ContentRenderer from "../../components/common/contentRenderer.jsx";
import CheckBoxSelector from "../../components/common/CheckBoxSelector.jsx";
import FormRendererContext from "../../services/context/FormRendererContext.js";
import {
  newFormSubmit,
  newFormSubmitForTriggers,
  updateJourneyDataForInstanceId,
} from "../../utils/form.js";
import SingleCheckBox from "../../components/common/SingleCheckBox.jsx";
import DropDownSelector from "../../components/common/DropDownSelector.jsx";
import DateInput from "../../components/common/DateInput.jsx";
import DOB from "../../components/common/DOB.jsx";
// import Email from "../../components/common/Email.jsx";
import EmailField from "../../components/newCommon/EmailField/EmailField.jsx";
import Signature from "../../components/common/Signature.jsx";
// import UploadFile from "../../components/common/UploadFile.jsx";
import UploadFile from "../../components/newCommon/UploadFile.jsx";
import Telephone from "../../components/common/Telephone.jsx";
import {
  callAthenaGetApi,
  callAthenaPostApi,
  callAthenaPutApi,
} from "../../utils/athena.js";
import DropDownWithSearch from "../../components/common/DropDownWithSearch.jsx";
import HealthHistoryAllergyComponent from "../../components/common/HealthHistoryAllergyComponent.jsx";
import axios from "axios";
import Loader from "../../components/common/loader.jsx";
import ModalBox from "../../components/common/modal.jsx";
import HealthHistoryMedicationComponent from "../../components/common/HealthHistoryMedicationComponent.jsx";
import AmericanPhoneField from "../../components/common/AmericanPhoneField.jsx";
import DynamicContentRenderer from "../../components/common/DynamicContentRenderer.jsx";
import moment from "moment";
import HeightField from "../../components/common/Height.jsx";
import DataGrid from "../../components/common/DataGrid.jsx";
import Columns from "../../components/newCommon/Column.jsx";
import PhoneField from "../../components/newCommon/PhoneField/PhoneField.jsx";
import Content from "../../components/newCommon/Content/Content.jsx";
import AlternaSleepProgressTracker from "../../components/progressTracker/AlternaSleepProgressTracker";
import ThemeSelectorContext from "../../services/context/ThemeSelectorContext";
const timezoneMapper = {
  est: -5,
  cst: -6,
  mst: -7,
  pst: -8,
  akst: -9,
  hst: -10,
};

const FormRenderer = ({
  formData,
  handleNextScreenPage,
  handleBackScreenPage,
  activeFormPageData,
  firstPageFirstFormID,
  formClass,
  isLastForm = false,
}) => {
  const [formSchema, setFormSchema] = useState(null);
  const [formAnswer, setFormAnswer] = useState(null);
  const [activeFormPage, setActiveFormPage] = useState(null);
  const [activeFormPageId, setActiveFormPageId] = useState(null);
  const [showloader, setShowLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalSubtitle, setModalSubtitle] = useState("");

  const [formattedAnswer, setFormattedAnswer] = useState(null);

  const [formValid, setFormValidation] = useState(true);

  const [formTriggers, setFormTriggers] = useState(null);

  const [allDepartmentsForSpecificForm, setAllDepartmentsForSpecificForm] =
    useState([]);
  const [allReasonsForSpecificForm, setAllReasonsForSpecificForm] =
    useState(null);

  // Progress Tracker states
  const [formPageSteps, setFormPageSteps] = useState([]);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  const { answerData, setAnswerData, socialKeys } =
    useContext(FormRendererContext);
  const {
    journeyData,
    deviceType,
    setJourneyData,
    activeScreenID,
    activeScreenPageID,
    completeJourneyAnswers,
    setCompleteJourneyAnswers,
    setHBxFirstName,
    setHBxLastName,
    setHBxEmail,
    setHBxDob,
    HBxReasonForVisit,
    setHBxReasonForVisit,
    journeyId,
    patientIdFromQP,
    appointmentIdFromQP,
    hashIdFromQP,
    allergyData,
    medicationData,
    patientTZ,
    setPatientTZ,
    insuranceCollectedStatus,
    paymentCollectedStatus,
    setScheduler_id,
    hashFromQP,
    qnABodyForTriggers,
    setQnABodyForTriggers,
    journeyInstanceId,
    setDepartment_id,
    isJourneyReadOnly,
  } = useContext(FormRendererContext);

  const { theme } = useContext(ThemeSelectorContext);

  let navigate = useNavigate();

  const paymentForm = "66ec5b455b3a1419fb717b99";
  const paymentFormProd = "6819ad9dc4f18e73b7d06d38";
  const insuranceForm = "66e918895b3a1419fb7132b7";
  const insuranceFormProd = "6819af55c4f18e73b7d06d4d";

  const getWidgetId = (data) => {
    const screens = data?.journey_schema?.screens || [];
    for (const screen of screens) {
      for (const page of screen?.screenPages || []) {
        const component = page?.components;
        if (component?.type === "scheduler-widget") {
          return component?.widget?.id || null;
        }
      }
    }
    return null; // Return null if no widget ID is found
  };

  async function uploadDemographics() {
    const demographicsAnswer = {
      firstName: answerData?.demographicsPatientFirstName?.value || "",
      middleName: answerData?.demographicsMiddleInitial?.value || "",
      lastName: answerData?.demographicsPatientLastName?.value || "",
      address: {
        streetAddress: answerData?.demographicsStreetAddress?.value || "",
        ZIP: parseInt(answerData?.demographicsZipCode?.value, 10) || "",
        city: answerData?.demographicsCity?.value || "",
        state: answerData?.demographicsState?.value || "",
        country: answerData?.demographicsCountry?.value || "",
      },
      phoneNumber: {
        home: answerData?.demographicsHomePhone?.value || "",
        work: answerData?.demographicsWorkPhone?.value || "",
        mobile: answerData?.demographicsMobilePhone?.value || "",
        // mobile: "(786) 767-7772demographicsMobilePhone",
      },
      sex: answerData?.demographicsLegalGender?.value || "",
      maritalStatus: answerData?.demographicsMaritalStatus?.value || "",
      email: answerData?.demographicsEmail?.value
        ? [answerData?.demographicsEmail?.value]
        : [],
      race: answerData?.demographicsRace?.value || "",
      ethnicity: answerData?.demographicsEthnicity?.value || "",
      SSN: answerData?.demographicsSsn?.value || "",
      language: answerData?.demographicsPreferredLanguage?.value || "",
      consentToCall:
        answerData?.demographicsConsentToCall?.value === "yes" ? true : false,
      consentToText:
        answerData?.demographicsConsentToTextYou?.value === "yes"
          ? true
          : false,
      emergencyContact: {
        name:
          answerData?.demographicsEmergencyFirstName?.value &&
          answerData?.demographicsEmergencyLastName?.value
            ? answerData?.demographicsEmergencyFirstName?.value +
              " " +
              answerData?.demographicsEmergencyLastName?.value
            : "",
        phone: answerData?.demographicsEmergencyMobilePhone?.value || "",
        relationship:
          answerData?.demographicsEmergencyRelationship?.value || "",
      },
    };
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const putDemographicsUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient`;
    try {
      // submit demographiocs data
      const demographicResponse = await callAthenaPutApi(
        putDemographicsUrl,
        demographicsAnswer,
      );
      // Check for demographic API failure
      if (!demographicResponse || demographicResponse.error) {
        alert("Demographics upload failed");
        return false;
      }

      // submit demographic image
      const binaryLinkUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/binary`;
      if (answerData?.demographicsPhoto?.value) {
        const file = answerData?.demographicsPhoto?.value;
        const fileName = file?.name;
        const fileType = file?.type;

        const imageResponse = await callAthenaPostApi(binaryLinkUrl, {
          contentType: fileType,
          fileName: fileName,
        });
        // Check for image upload URL failure
        if (!imageResponse || imageResponse.error) {
          alert("Failed to get image upload URL");
          return false;
        }

        const { uploadUrl } = imageResponse?.data?.HBx;
        const { fileUrl } = imageResponse?.data?.HBx;
        const formData = new FormData();
        formData.append("file", file);
        await axios.put(uploadUrl, file);

        // delaying 300 ms for complete upload of image on s3 server
        await new Promise((resolve) => setTimeout(resolve, 300));

        const postUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/driverslicense`;
        const fileResponse = await callAthenaPostApi(postUploadUrl, {
          fileName: fileName,
          contentType: fileType,
          HBxUrl: fileUrl,
        });
        // Check for final image API failure
        if (!fileResponse || fileResponse.error) {
          alert("Image metadata submission failed");
          return false;
        }
      }
      return true;
    } catch (error) {
      // Catch any other unexpected errors
      alert("Error during demographics upload:", error);
      return false;
    }
  }
  async function uploadSleepTest() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const schedulerId = getWidgetId(journeyData);
    try {
      // submit demographic image
      const binaryLinkUrl = `${API_URL}/api/v1/booking/upload-url/${schedulerId}/${hashFromQP}`;
      if (answerData?.uploadSleepTest?.value) {
        const file = answerData?.uploadSleepTest?.value;
        const fileName = file?.name;
        const fileType = file?.type;

        const imageResponse = await callAthenaPostApi(binaryLinkUrl, {
          contentType: fileType,
          fileName: fileName,
        });
        // Check for image upload URL failure
        if (!imageResponse || imageResponse.error) {
          alert("Failed to get image upload URL");
          return false;
        }

        const { uploadUrl } = imageResponse?.data;
        const { fileUrl } = imageResponse?.data;
        const formData = new FormData();
        formData.append("file", file);
        await axios.put(uploadUrl, file);

        // delaying 300 ms for complete upload of image on s3 server
        await new Promise((resolve) => setTimeout(resolve, 300));

        const postUploadUrl = `${API_URL}/api/v1/booking/document/${schedulerId}/${hashFromQP}`;
        const fileResponse = await callAthenaPostApi(postUploadUrl, {
          fileName: fileName,
          contentType: fileType,
          fileUrl: fileUrl,
        });
        // Check for final image API failure
        if (!fileResponse || fileResponse.error) {
          alert("Image metadata submission failed");
          return false;
        }
      }
      return true;
    } catch (error) {
      // Catch any other unexpected errors
      alert("Error during sleep test upload:", error);
      return false;
    }
  }
  async function uploadAdditionalInfo() {
    if (answerData?.additionalInfoConsent?.value === "yes") {
      const additionalInfo = {
        sexualOrientation: answerData?.sexualOrientation?.value || "",
        sexualOrientationOther: "",
        genderIdentity: answerData?.genderIdentity?.value || "",
        genderOther: "",
        sexAtBirth: answerData?.sexAtBirth?.value || "",
        pronouns: answerData?.pronouns?.value || "",
        homebound: answerData?.homebound?.value === "yes" ? "true" : "false",
        referralSourceId: answerData?.referralSourceId?.value || "",
        referralSourceOther: "",
      };
      const API_URL = process.env.REACT_APP_SCHEDULER_URL;
      const uploadAdditionalInfoUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient`;
      try {
        const response = await callAthenaPutApi(
          uploadAdditionalInfoUrl,
          additionalInfo,
        );
        // Check for API failure
        if (!response || response.error) {
          alert("Additional info upload failed");
          return false;
        }
        if (
          journeyId === "6710106ced976ad58926ecb1" ||
          journeyId === "67101074ed976ad58926ecb2"
        ) {
          return uploadInsurance();
        }

        // If successful, return true
        return true;
      } catch (error) {
        // Catch any unexpected errors
        alert("Error during additional info upload:", error);
        return false;
      }
    }
    return true;
  }
  function dateFormatter(date) {
    const formattedDate = moment(date?.$d).format("MM/DD/YYYY");
    return formattedDate;
  }
  async function uploadInsurance() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const uploadInsuranceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage`;
    const appointmentCoverageUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/coverage`;

    if (answerData?.areYouUsingYourInsuranceForTheVisit?.value === "yes") {
      //Insurance
      const insPlans = [
        {
          insurancePackageId: "0",
          name: "*SELF PAY*",
          ranking: "1",
          percentage: "65.36458333333333333333333333333333333333",
          address: {},
        },
        {
          insurancePackageId: "31724",
          name: "HUMANA (PPO)",
          productTypeName: "PPO",
          ranking: "2",
          percentage: "11.1328125",
          phone: "(800) 558-4444",
          address: {
            streetaddress: "PO BOX 14601",
            city: "LEXINGTON",
            state: "KY",
            ZIP: "40512-4601",
          },
        },
        {
          insurancePackageId: "20995",
          name: "HUMANA - GOLD PLUS (MEDICARE REPLACEMENT HMO)",
          productTypeName: "Medicare HMO",
          ranking: "3",
          percentage: "2.47395833333333333333333333333333333333",
          phone: "(800) 448-6262",
          address: {
            streetaddress: "PO BOX 14601",
            city: "LEXINGTON",
            state: "KY",
            ZIP: "40512-4601",
          },
        },
        {
          insurancePackageId: "1352",
          name: "AETNA",
          productTypeName: "OTHER",
          ranking: "4",
          percentage: "1.82291666666666666666666666666666666667",
          phone: "(888) 632-3862",
          address: {
            streetaddress: "PO BOX 981106",
            city: "EL PASO",
            state: "TX",
            ZIP: "79998-1106",
          },
        },
        {
          insurancePackageId: "-500",
          name: "PAYMENT PLAN",
          ranking: "5",
          percentage: "1.43229166666666666666666666666666666667",
          address: {},
        },
        {
          insurancePackageId: "8477",
          name: "BCBS-MA: BCBS (PPO)",
          productTypeName: "PPO",
          ranking: "6",
          percentage: ".9114583333333333333333333333333333333333",
          phone: "(800) 882-2060",
          address: {
            streetaddress: "PO BOX 986020",
            city: "BOSTON",
            state: "MA",
            ZIP: "02298-6020",
          },
        },
        {
          insurancePackageId: "92125",
          name: "AETNA - OLYMPUS HEALTHCARE (PPO)",
          productTypeName: "PPO",
          ranking: "7",
          percentage: ".5859375",
          phone: "(866) 936-1225",
          address: {
            streetaddress: "PO BOX 30259",
            city: "TAMPA",
            state: "FL",
            ZIP: "33630-3259",
          },
        },
        {
          insurancePackageId: "569524",
          name: "BCBS-RI (MEDICARE REPLACEMENT/ADVANTAGE - PPO)",
          productTypeName: "Medicare PPO",
          ranking: "7",
          percentage: ".5859375",
          phone: "(800) 230-9050",
          address: {
            streetaddress: "500 EXCHANGE ST",
            city: "PROVIDENCE",
            state: "RI",
            ZIP: "02903-2630",
          },
        },
      ];

      const insurancePackageId = answerData?.insuranceCompanyName?.value;
      const selectedPlan = insPlans.find(
        (plan) => plan.insurancePackageId === insurancePackageId,
      );
      const insuranceProductTypeName = selectedPlan?.productTypeName || "";
      const insuranceName = selectedPlan?.name || "";

      const insuranceData = {
        insurancePackageId: insurancePackageId
          ? parseInt(insurancePackageId, 10)
          : "",
        insuranceProductTypeName: insuranceProductTypeName,
        insuranceName: insuranceName,
        policyNumber: answerData?.policyNumber?.value || "",
        groupID: answerData?.policyGroupId?.value || "",
        // sequenceNumber: 1,
        relationshipToInsured:
          answerData?.patientsRelationshipToInsuranceHolder?.value || "",
        policyHolder: {
          firstName: answerData?.policyHolderFirstName?.value || "",
          middleName: answerData?.policyHolderMiddleName?.value || "",
          lastName: answerData?.policyHolderLastName?.value || "",
          sex: answerData?.policyHolderGender?.value || "",
          DOB: answerData?.policyHolderDOB?.value
            ? dateFormatter(answerData?.policyHolderDOB?.value)
            : "",
          address: {
            streetAddress: answerData?.policyHolderAddress?.value || "",
            ZIP: parseInt(answerData?.policyHolderZipcode?.value, 10) || "",
            city: answerData?.policyHolderCity?.value || "",
            state: answerData?.policyHolderState?.value || "",
            country: answerData?.policyHolderCountry?.value || "",
          },
        },
      };

      insuranceData["sequenceNumber"] = 1;
      try {
        const coverageResponse = await callAthenaGetApi(uploadInsuranceUrl);

        if (!coverageResponse || coverageResponse.error) {
          alert("get coverage failed");
          return false;
        }

        const HBxData = coverageResponse.data?.HBx;
        insuranceData["sequenceNumber"] = HBxData?.length
          ? HBxData?.length + 1
          : 1;

        const insuranceResponse = await callAthenaPostApi(
          uploadInsuranceUrl,
          insuranceData,
        );

        if (!insuranceResponse || insuranceResponse.error) {
          alert("Insurance upload failed");
          return false;
        }

        const { HBx } = insuranceResponse.data;
        const insuranceId = HBx?.id;

        const appointmentCoverageResponse = await callAthenaPutApi(
          appointmentCoverageUrl,
          {
            primaryCoverageId: insuranceId,
          },
        );

        if (!appointmentCoverageResponse || appointmentCoverageResponse.error) {
          alert("Appointment coverage update failed");
          return false;
        }
        const handleImageUpload = async () => {
          if (answerData?.snapAPhotographOfYourInsuranceCard?.value) {
            const file1 = answerData?.snapAPhotographOfYourInsuranceCard?.value;

            const file2 =
              answerData?.snapAPhotographOfYourInsuranceCardBackSide?.value;

            try {
              // Create a canvas to combine the two images
              const canvas = document.createElement("canvas");
              const ctx = canvas.getContext("2d");

              // Load both images as Image objects
              const img1 = new Image();
              const img2 = new Image();

              img1.src = URL.createObjectURL(file1);
              img2.src = URL.createObjectURL(file2);

              const loadImages = () =>
                new Promise((resolve, reject) => {
                  let loadedCount = 0;

                  const onLoad = () => {
                    loadedCount += 1;
                    if (loadedCount === 2) resolve();
                  };

                  const onError = (error) => reject(error);

                  img1.onload = onLoad;
                  img2.onload = onLoad;
                  img1.onerror = onError;
                  img2.onerror = onError;
                });

              // Wait for both images to load
              await loadImages();

              // Set canvas size to combine both images (vertically stacked in this example)
              canvas.width = Math.max(img1.width, img2.width);
              canvas.height = img1.height + img2.height;

              // Draw both images on the canvas
              ctx.drawImage(img1, 0, 0);
              ctx.drawImage(img2, 0, img1.height);

              // Convert the combined image to binary (Blob)
              const combinedImageBlob = await new Promise((resolve) => {
                canvas.toBlob((blob) => resolve(blob), "image/jpeg");
              });

              const binaryLinkUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/binary`;

              const res = await callAthenaPostApi(binaryLinkUrl, {
                contentType: combinedImageBlob?.type,
                fileName: "combined-insurance.jpg",
              });

              const { uploadUrl, fileUrl } = res?.data?.HBx;

              const postUploadUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage/image`;
              try {
                await axios.put(uploadUrl, combinedImageBlob);

                // delaying 300 ms for complete upload of image on s3 server
                await new Promise((resolve) => setTimeout(resolve, 300));

                await callAthenaPostApi(postUploadUrl, {
                  fileName: "combined-insurance.jpg",
                  coverageId: insuranceId,
                  HBxUrl: fileUrl,
                });
              } catch (error) {
                alert(`Error uploading combined-insurance.jpg:`, error);
                return false;
              }
            } catch (error) {
              console.error("Error combining and uploading files:", error);
            }
          }
        };

        await handleImageUpload();

        return true; // Successful completion
      } catch (error) {
        alert("Error during get coverage fetch:", error);
        return false;
      }
    } else {
      return true; // Successful completion
    }
  }

  async function callAthenaAPIs() {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    const getGenderUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/configuration/genderIdentity`;
    const getReferralSourceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/configuration/referralsources`;
    const getInsuranceUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/insuranceplan`;
    const getCoverageUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/coverage`;
    const getMedicalHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/medicalhistory`;
    const getSocialHistoryUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/questionnaire/socialhistory`;
    const getPrivacyInfoUrl = `${API_URL}/api/v1/checkin/${hashIdFromQP}/patient/consent`;
    try {
      // Health history
      if (
        formData?.formId === "66e947e15b3a1419fb71449f" ||
        formData?.formId === "68525b7b4ef9cc55588fb851" ||
        formData?.formId === "6819aff5c4f18e73b7d06d59"
      ) {
        await Promise.all([callAthenaGetApi(getMedicalHistoryUrl)]);
      }

      // Social history
      if (
        formData?.formId === "66e919bd5b3a1419fb7132e5" ||
        formData?.formId === "68525b9d4ef9cc55588fb852" ||
        formData?.formId === "6819b02fc4f18e73b7d06d5d"
      ) {
        await Promise.all([callAthenaGetApi(getSocialHistoryUrl)]);
      }

      // Privacy info
      if (
        formData?.formId === "66e91d3e5b3a1419fb7132fa" ||
        formData?.formId === "68525bcd4ef9cc55588fb853" ||
        formData?.formId === "6819b084c4f18e73b7d06d61"
      ) {
        await callAthenaGetApi(getPrivacyInfoUrl);
      }
    } catch (error) {
      alert("Error during Athena API calls:", error);
    }
  }

  const fetchFormSchema = async (activeComponent) => {
    setFormSchema(activeComponent?.form?.form_schema?.formData);
    // setActiveFormPage(activeComponent?.form?.form_schema?.formData[0].content);
    // setActiveFormPageId(activeComponent?.form?.form_schema?.formData[0].id);
    setFormAnswer(activeComponent?.form);
    if (activeComponent?.updatedTriggers) {
      setFormTriggers({
        triggers: activeComponent?.updatedTriggers,
        waitForWorkflowCompletion:
          activeComponent?.waitForWorkflowCompletion || false,
        singleFormBody: false,
      });
    } else if (activeComponent?.form?.triggers) {
      setFormTriggers({
        triggers: activeComponent?.form?.triggers,
        waitForWorkflowCompletion:
          activeComponent?.waitForWorkflowCompletion || false,
        singleFormBody: true,
      });
    } else {
      setFormTriggers({
        triggers: [],
        waitForWorkflowCompletion: false,
        singleFormBody: false,
      });
    }
  };

  const deepCloneWithFiles = (obj) => {
    return structuredClone(obj);
  };

  // Function to format date and time as 'dd/MM/yyyy HH:mm:ss'
  const formatTimestamp = (dateInput) => {
    const date = new Date(dateInput);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  };

  function addOneYearToDate(dateInput) {
    const date = new Date(dateInput);

    // Add one year to the date
    date.setFullYear(date.getFullYear() + 1);

    const newDay = String(date.getDate()).padStart(2, "0");
    const newMonth = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const newYear = date.getFullYear();

    return `${newMonth}/${newDay}/${newYear}`;
  }

  // Function to add an answer to a specific form, form page, and question
  function addAnswerToTriggerBody(formId, activeFormPageId, question, answer) {
    const questionKey = question?.key;
    const questionLabel = question?.label;
    setQnABodyForTriggers((prevState) => {
      // Create a copy of the previous state
      const newState = { ...prevState };

      // If the form doesn't exist yet, create it
      if (!newState[formId]) {
        newState[formId] = {};
      }

      // If the form page doesn't exist yet, create it
      if (!newState[formId][activeFormPageId]) {
        newState[formId][activeFormPageId] = {};
      }

      // Determine the answer value, handling boolean values properly
      let answerValue;
      if (answer?.label !== undefined) {
        answerValue = answer.label;
      } else if (answer?.value !== undefined) {
        answerValue = answer.value; // This now properly handles boolean values
      }

      // Add the question-answer pair to the specific form page
      if (question?.type === "file") {
        if (answer?.value instanceof File) {
          newState[formId][activeFormPageId][questionKey] = {
            question: questionLabel,
            answer: question?.fileId,
          };
        } else
          newState[formId][activeFormPageId][questionKey] = {
            question: questionLabel,
            answer: null,
          };
      } else {
        newState[formId][activeFormPageId][questionKey] = {
          question: questionLabel,
          answer: answerValue,
        };
      }

      if (answer?.time) {
        newState[formId][activeFormPageId][questionKey].time = answer?.time;
      }
      // Return the updated state
      return newState;
    });
  }

  const clearDependentQuestions = (
    changedQuestionKey,
    tempAnswerList,
    updatedAnswerData,
    updatedJourneyAnswers,
    tempFormAnswer,
    updatedJourneyData,
  ) => {
    // Find all questions that depend on the changed question
    const dependentQuestions = [];

    // Check in form schema
    tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
      formPage?.content?.components?.forEach((component) => {
        if (component?.conditional?.when === changedQuestionKey) {
          dependentQuestions.push(component.key);
        }
      });
    });

    // Check in journey schema
    updatedJourneyData?.journey_schema?.screens?.forEach((screen) => {
      screen?.screenPages?.forEach((screenPage) => {
        screenPage?.components?.form?.form_schema?.formData?.forEach(
          (formPage) => {
            formPage?.content?.components?.forEach((component) => {
              if (component?.conditional?.when === changedQuestionKey) {
                dependentQuestions.push(component.key);
              }
            });
          },
        );
      });
    });

    // Remove duplicates
    const uniqueDependentQuestions = [...new Set(dependentQuestions)];

    // For each dependent question, check if it should be hidden and clear if needed
    uniqueDependentQuestions.forEach(async (depQuestionKey) => {
      // Find the question object to check its conditional logic
      let questionObj = null;

      // Search in form schema
      tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
        formPage?.content?.components?.forEach((component) => {
          if (component.key === depQuestionKey) {
            questionObj = component;
          }
        });
      });

      const show = shouldQuestionBeVisible(questionObj, updatedAnswerData);

      if (questionObj && !show) {
        // Clear this question's answer
        clearQuestionAnswer(
          depQuestionKey,
          tempAnswerList,
          updatedAnswerData,
          updatedJourneyAnswers,
          tempFormAnswer,
          updatedJourneyData,
        );

        // Recursively clear its dependent questions
        clearDependentQuestions(
          depQuestionKey,
          tempAnswerList,
          updatedAnswerData,
          updatedJourneyAnswers,
          tempFormAnswer,
          updatedJourneyData,
        );
      }
    });
  };

  const clearQuestionAnswer = (
    questionKey,
    tempAnswerList,
    updatedAnswerData,
    updatedJourneyAnswers,
    tempFormAnswer,
    updatedJourneyData,
  ) => {
    // Remove from tempAnswerList
    const answerIndex = tempAnswerList.findIndex(
      (item) => item.key === questionKey,
    );
    if (answerIndex !== -1) {
      tempAnswerList.splice(answerIndex, 1);
    }

    // Remove from updatedAnswerData
    delete updatedAnswerData[questionKey];

    // Remove from updatedJourneyAnswers
    const journeyIndex = updatedJourneyAnswers.findIndex(
      (item) => item.key === questionKey,
    );
    if (journeyIndex !== -1) {
      updatedJourneyAnswers.splice(journeyIndex, 1);
    }

    // Clear from form structure
    tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
      formPage?.content?.components?.forEach((component) => {
        if (component.key === questionKey) {
          delete component.answer;
          component.formValidation = false;
        }
      });
    });

    // Clear from journey structure
    updatedJourneyData?.journey_schema?.screens?.forEach((screen) => {
      screen?.screenPages?.forEach((screenPage) => {
        screenPage?.components?.form?.form_schema?.formData?.forEach(
          (formPage) => {
            formPage?.content?.components?.forEach((component) => {
              if (component.key === questionKey) {
                delete component.answer;
                component.formValidation = false;
              }
            });
          },
        );
      });
    });
  };
  const shouldQuestionBeVisible = (questionObj, updatedAnswerData) => {
    if (!questionObj?.conditional?.when || !questionObj?.conditional?.eq) {
      return true; // No conditional logic = always visible
    }

    const dependentAnswer =
      updatedAnswerData[questionObj.conditional.when]?.value;
    const expectedValue = questionObj.conditional.eq;
    const showIfMatch = questionObj.conditional.show || false;

    let matches = false;

    if (
      typeof dependentAnswer === "string" &&
      dependentAnswer === expectedValue
    ) {
      matches = true;
    } else if (
      Array.isArray(dependentAnswer) &&
      dependentAnswer.includes(expectedValue)
    ) {
      matches = true;
    } else if (
      Array.isArray(expectedValue) &&
      typeof dependentAnswer === "string" &&
      expectedValue.includes(dependentAnswer)
    ) {
      matches = true;
    } else if (
      typeof dependentAnswer === "boolean" &&
      dependentAnswer == expectedValue
    ) {
      matches = true;
    } else if (
      typeof dependentAnswer === "object" &&
      dependentAnswer !== null &&
      !Array.isArray(dependentAnswer)
    ) {
      // Handle object format answers like { optionA: true, optionB: false, optionC: true }
      if (
        typeof expectedValue === "string" &&
        dependentAnswer[expectedValue] === true
      ) {
        matches = true;
      } else if (
        Array.isArray(expectedValue) &&
        expectedValue.some((key) => dependentAnswer[key] === true)
      ) {
        matches = true;
      }
    }

    return matches ? showIfMatch : !showIfMatch;
  };

  const setAnswer = async (question, answer) => {
    if (question?.type === "datetime") {
      if (answer?.value?.$d) {
        const originalDate = new Date(answer?.value?.$d);
        const utcDate = new Date(
          Date.UTC(
            originalDate.getFullYear(),
            originalDate.getMonth(),
            originalDate.getDate(),
            0,
            0,
            0,
            0,
          ),
        );
        answer.value = utcDate.toISOString();
      }
    }
    if (
      (formData?.formId === "6819ab3ec4f18e73b7d06d0e" ||
        formData?.formId === "685259b64ef9cc55588fb849" ||
        formData?.formId === "686b682dc92b0a640c372127" ||
        formData?.formId === "66fe0d935b3a1419fb71a96d") &&
      question?.key === "patientDepartmentForSchedulerForSpecificForm"
    ) {
      setDepartment_id(answer?.value);
      fetchAllReasons(answer?.value);
    }
    // let tempAnswerList = JSON.parse(JSON.stringify(formattedAnswer?.answers));
    let tempAnswerList = deepCloneWithFiles(formattedAnswer?.answers);
    const questionKey = question?.key;
    addAnswerToTriggerBody(
      formData?.formId,
      activeFormPageId,
      question,
      answer,
    );

    if (questionKey === "HBxFirstName") {
      setHBxFirstName(answer?.value);
    }
    if (questionKey === "HBxReasonForVisit") {
      setHBxReasonForVisit(answer?.value);
    }
    if (questionKey === "HBxLastName") {
      setHBxLastName(answer?.value);
    }
    if (questionKey === "HBxEmail") {
      setHBxEmail(answer?.value);
    }
    if (questionKey === "HBxDob") {
      setHBxDob(answer?.value);
    }

    if (questionKey === "preferredTimezoneForAppointmentBooking") {
      setPatientTZ(timezoneMapper[answer?.value]);
    }

    let index = tempAnswerList.findIndex((item) => item.key === questionKey);
    if (index === -1) {
      tempAnswerList.push({
        key: questionKey,
        question: question?.label,
        answer,
      });
    } else {
      tempAnswerList[index].answer = answer;
    }
    setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));

    // let tempFormAnswer = JSON.parse(JSON.stringify(formAnswer));
    let tempFormAnswer = deepCloneWithFiles(formAnswer);
    tempFormAnswer?.form_schema?.formData?.map((formPage) => {
      // formPage?.contents && formPage?.content?.components && formPage?.content?.components.map((item)=>{
      formPage?.content?.components.map((item) => {
        if (item?.key === questionKey) {
          item.answer = answer;
          if (answer && answer?.value) item.formValidation = true;
          else item.formValidation = false;
        }
      });
    });
    setFormAnswer(tempFormAnswer);
    setFormSchema(tempFormAnswer?.form_schema?.formData);

    for (let i = 0; i < tempFormAnswer?.form_schema?.formData?.length; i++) {
      if (tempFormAnswer?.form_schema?.formData[i].id === activeFormPageId) {
        setActiveFormPage(tempFormAnswer?.form_schema?.formData[i]?.content);
      }
    }

    // let updatedAnswerData = JSON.parse(JSON.stringify(answerData));
    let updatedAnswerData = deepCloneWithFiles(answerData);
    updatedAnswerData[questionKey] = answer;
    setAnswerData(updatedAnswerData);
    // console.log(tempFormAnswer);

    let updatedJourneyAnswers = JSON.parse(
      JSON.stringify(completeJourneyAnswers),
    );
    let indexJourneyAnswer = updatedJourneyAnswers.findIndex(
      (item) => item.key === questionKey,
    );
    if (indexJourneyAnswer === -1) {
      updatedJourneyAnswers.push({
        key: questionKey,
        question: question?.label,
        answer,
      });
    } else {
      updatedJourneyAnswers[indexJourneyAnswer].answer = answer;
    }
    setCompleteJourneyAnswers(updatedJourneyAnswers);

    // let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let updatedJourneyData = deepCloneWithFiles(journeyData);

    let screens = updatedJourneyData?.journey_schema?.screens;

    for (let i = 0; i < screens?.length; i++) {
      if (screens[i]?.id === activeScreenID) {
        let screenPages = screens[i]?.screenPages;
        for (let j = 0; j < screenPages?.length; j++) {
          if (screenPages[j]?.id === activeScreenPageID) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              if (form[idx]?.id === activeFormPageId) {
                let formContent = form[idx]?.content?.components;
                formContent?.map((ques) => {
                  if (ques?.key === questionKey) ques.answer = answer;
                  if (answer && answer?.value) ques.formValidation = true;
                  else ques.formValidation = false;
                });
              }
            }
          }
        }
      }
    }
    setJourneyData(updatedJourneyData);

    // Clear dependent questions if this answer change affects conditional logic
    clearDependentQuestions(
      questionKey,
      tempAnswerList,
      updatedAnswerData,
      updatedJourneyAnswers,
      tempFormAnswer,
      updatedJourneyData,
    );

    const iDontWantToAddMyCardOnFile =
      updatedAnswerData?.["iDontWantToAddMyCardOnFile"]?.value == true;
    if (
      !iDontWantToAddMyCardOnFile &&
      questionKey === "selectHowSynaptrxSleepCanUseYourCardOnFile"
    ) {
      const UseYourCardOnFile =
        updatedAnswerData?.selectHowSynaptrxSleepCanUseYourCardOnFile?.value ||
        "";
      if (UseYourCardOnFile) {
        const API_URL = process.env.REACT_APP_SCHEDULER_URL;
        const paymentUploadUrl =
          UseYourCardOnFile === "singleAppointment"
            ? `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/singleappointment`
            : `${API_URL}/api/v1/checkin/${hashIdFromQP}/appointment/contract/oneyear`;
        await callAthenaGetApi(paymentUploadUrl);
      }
    }
    if (
      (formData?.formId === "67f7cb7393a8e4fac0461c2e" ||
        formData?.formId === "680b7a141b878c3e8f5b5072" ||
        formData?.formId === "685cf4f79689d33502580753" ||
        formData?.formId === "685cf5dd60c6b60a7aadfa83" ||
        formData?.formId === "67fe43741b878c3e8f5b33d0" ||
        formData?.formId === "6870f8ace3e9c17d11fcf510" ||
        formData?.formId === "6836ed5866e091a6310b50b0") &&
      (question?.key === "heightInches" || question?.key === "weightLbs")
    ) {
      // Get current height and weight values
      const heightInches =
        question?.key === "heightInches"
          ? answer?.value
          : updatedAnswerData?.heightInches?.value;

      const weightLbs =
        question?.key === "weightLbs"
          ? answer?.value
          : updatedAnswerData?.weightLbs?.value;

      // Helper function to validate numeric input
      const isValidNumber = (value, min = 0, max = Infinity) => {
        const num = parseFloat(value);
        return value && !isNaN(num) && num > min && num <= max;
      };

      // Validate inputs
      const isValidHeight = isValidNumber(heightInches, 0, 120);
      const isValidWeight = isValidNumber(weightLbs, 0, 1000);

      // Helper function to update answer in all data structures
      const updateAnswerInStructures = (
        key,
        question,
        answer,
        isValid = true,
      ) => {
        // Update tempAnswerList
        const existingIndex = tempAnswerList.findIndex(
          (item) => item.key === key,
        );
        const answerItem = { key, question, answer };

        if (existingIndex === -1) {
          tempAnswerList.push(answerItem);
        } else {
          tempAnswerList[existingIndex].answer = answer;
        }

        // Update updatedAnswerData
        updatedAnswerData[key] = answer;

        // Update journey answers
        const journeyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === key,
        );
        if (journeyIndex === -1) {
          updatedJourneyAnswers.push(answerItem);
        } else {
          updatedJourneyAnswers[journeyIndex].answer = answer;
        }

        // Update form structure - use forEach instead of map for side effects
        tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
          formPage?.content?.components?.forEach((item) => {
            if (item?.key === key) {
              item.answer = answer;
              item.formValidation = isValid;
            }
          });
        });

        // Update journey data structure and find form IDs
        let targetFormId = null;
        let targetFormPageId = null;

        screens?.forEach((screen) => {
          if (screen?.id === activeScreenID) {
            screen?.screenPages?.forEach((screenPage) => {
              if (screenPage?.id === activeScreenPageID) {
                const form =
                  screenPage?.components?.form?.form_schema?.formData;
                form?.forEach((formPageItem) => {
                  if (formPageItem?.id === activeFormPageId) {
                    formPageItem?.content?.components?.forEach((ques) => {
                      if (ques?.key === key) {
                        if (!targetFormId)
                          targetFormId = screenPage?.components?.formId;
                        if (!targetFormPageId)
                          targetFormPageId = formPageItem?.id;
                        ques.answer = answer;
                        ques.formValidation = isValid;
                      }
                    });
                  }
                });
              }
            });
          }
        });

        // Add to trigger body
        addAnswerToTriggerBody(
          targetFormId || formData?.formId,
          targetFormPageId || activeFormPageId,
          { label: question, key, type: key === "bmi" ? "textfield" : "radio" },
          answer,
        );
      };

      if (isValidHeight && isValidWeight) {
        const heightNum = parseFloat(heightInches);
        const weightNum = parseFloat(weightLbs);
        const calculatedBMI = (
          (weightNum / (heightNum * heightNum)) *
          703
        ).toFixed(2);

        // Validate calculated BMI
        if (isValidNumber(calculatedBMI, 0, 200)) {
          const bmiAnswer = { value: calculatedBMI };

          // Update BMI field
          updateAnswerInStructures("bmi", "BMI", bmiAnswer, true);

          // Update BMI threshold question based on calculated value
          const bmiThresholdAnswer = {
            value: parseFloat(calculatedBMI) >= 30 ? "Yes" : "No",
          };
          updateAnswerInStructures(
            "isBmiGreaterThanOrEqualTo30",
            "Is BMI Greater than or Equal to 30?",
            bmiThresholdAnswer,
            true,
          );
        } else {
          console.warn("Calculated BMI is invalid:", calculatedBMI);
        }
      } else {
        // Handle invalid height/weight - clear BMI values
        const emptyAnswer = { value: "" };

        // Clear BMI field
        updateAnswerInStructures("bmi", "BMI", emptyAnswer, false);

        // Clear BMI threshold question
        updateAnswerInStructures(
          "isBmiGreaterThanOrEqualTo30",
          "Is BMI Greater than or Equal to 30?",
          emptyAnswer,
          false,
        );
      }

      // Apply all state updates once at the end
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }
    if (
      (formData?.formId === "689c1758af230220db3f8d92" ||
        formData?.formId === "689afb02e329f8c3d0964122") &&
      question?.key === "procedures"
    ) {
      // SuperBill Charges Calculation
      const calculatedTotals = {
        totalCharges: 0,
        totalPaid: 0,
        totalDue: 0,
      };

      // Helper function to safely parse float values
      const safeParseFloat = (value, defaultValue = 0) => {
        const parsed = parseFloat(value || 0);
        return isNaN(parsed) ? defaultValue : parsed;
      };

      // Recursive function to find and calculate procedure totals
      const findAndCalculateProcedureTotals = (components) => {
        if (!Array.isArray(components)) return;

        components.forEach((component) => {
          // Check if this is the procedures component
          if (
            component?.key === "procedures" &&
            component?.type === "datagrid" &&
            Array.isArray(component?.answer?.value)
          ) {
            // Calculate totals from procedure data
            component.answer.value.forEach((procedure) => {
              calculatedTotals.totalCharges += safeParseFloat(procedure?.fees);
              calculatedTotals.totalPaid += safeParseFloat(
                procedure?.amountPaid,
              );
              calculatedTotals.totalDue += safeParseFloat(procedure?.amountDue);
            });
          }

          // Recursively check nested components
          if (Array.isArray(component?.components)) {
            findAndCalculateProcedureTotals(component.components);
          }
        });
      };

      // Helper function to update total field answers in all data structures
      const updateTotalFieldInStructures = (fieldKey, calculatedValue) => {
        const answer = { value: calculatedValue.toString() };
        const question = fieldKey
          .replace(/([A-Z])/g, " $1")
          .replace(/^./, (str) => str.toUpperCase()); // Convert camelCase to Title Case

        // Update tempAnswerList
        const existingIndex = tempAnswerList.findIndex(
          (item) => item.key === fieldKey,
        );
        const answerItem = { key: fieldKey, question, answer };

        if (existingIndex === -1) {
          tempAnswerList.push(answerItem);
        } else {
          tempAnswerList[existingIndex] = answerItem;
        }

        // Update updatedAnswerData
        updatedAnswerData[fieldKey] = answer;

        // Update journey answers
        const journeyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === fieldKey,
        );
        if (journeyIndex === -1) {
          updatedJourneyAnswers.push(answerItem);
        } else {
          updatedJourneyAnswers[journeyIndex] = answerItem;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.forEach((formPage) => {
          formPage?.content?.components?.forEach((component) => {
            if (component?.key === fieldKey) {
              if (!component.answer) component.answer = {};
              component.answer.value = calculatedValue.toString();
              component.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let targetFormId = null;
        let targetFormPageId = null;

        screens?.forEach((screen) => {
          screen?.screenPages?.forEach((screenPage) => {
            const form = screenPage?.components?.form?.form_schema?.formData;
            form?.forEach((formPageItem) => {
              formPageItem?.content?.components?.forEach((component) => {
                if (component?.key === fieldKey) {
                  if (!targetFormId)
                    targetFormId = screenPage?.components?.formId;
                  if (!targetFormPageId) targetFormPageId = formPageItem?.id;

                  if (!component.answer) component.answer = {};
                  component.answer.value = calculatedValue.toString();
                  component.formValidation = true;
                }
              });
            });
          });
        });

        // Add to trigger body
        addAnswerToTriggerBody(
          targetFormId || formData?.formId,
          targetFormPageId || activeFormPageId,
          { label: question, key: fieldKey, type: "textfield" },
          answer,
        );
      };

      // Process all form pages to find procedure information
      const formPages = tempFormAnswer?.form_schema?.formData;
      if (Array.isArray(formPages)) {
        // Calculate totals from procedure information
        formPages.forEach((page) => {
          const components = page?.content?.components;
          if (components) {
            findAndCalculateProcedureTotals(components);
          }
        });

        // Update all total fields with calculated values
        updateTotalFieldInStructures(
          "totalCharges",
          calculatedTotals.totalCharges,
        );
        updateTotalFieldInStructures("totalPaid", calculatedTotals.totalPaid);
        updateTotalFieldInStructures("totalDue", calculatedTotals.totalDue);
      }

      // Apply all state updates once at the end
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }

    if (
      formData?.formId === "682ee8aa1b878c3e8f5ba664" &&
      question?.key === "screeningConsentPatientSignature"
    ) {
      // Use the updated answerData to get current values
      const screeningConsentPatientSignature = answer?.value;

      // Add validation to ensure both values are valid numbers and reasonable
      const isValidAnswer =
        screeningConsentPatientSignature &&
        screeningConsentPatientSignature !== "" &&
        screeningConsentPatientSignature !== null;

      if (isValidAnswer) {
        const consentAnswer = { value: "Yes" };
        const consentQuestion = {
          label: "Consent(s) signed?",
          key: "consentSSigned",
          type: "radio",
        };

        // Update tempAnswerList
        let consentIndex = tempAnswerList.findIndex(
          (item) => item.key === consentQuestion?.key,
        );
        if (consentIndex === -1) {
          tempAnswerList.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          tempAnswerList[consentIndex].answer = consentAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[consentQuestion?.key] = consentAnswer;

        // Update journey answers
        let consentjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === consentQuestion?.key,
        );
        if (consentjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          updatedJourneyAnswers[consentjourneyIndex].answer = consentAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === consentQuestion?.key) {
              item.answer = consentAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === consentQuestion?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = consentAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          consentQuestion,
          consentAnswer,
        );

        // Re-apply the state updates with BMI included
        setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
        setAnswerData(updatedAnswerData);
        setCompleteJourneyAnswers(updatedJourneyAnswers);
        setFormAnswer(tempFormAnswer);
        setFormSchema(tempFormAnswer?.form_schema?.formData);
        setJourneyData(updatedJourneyData);
      } else {
        const consentAnswer = { value: "No" };
        const consentQuestion = {
          label: "Consent(s) signed?",
          key: "consentSSigned",
          type: "radio",
        };

        // Update tempAnswerList
        let consentIndex = tempAnswerList.findIndex(
          (item) => item.key === consentQuestion?.key,
        );
        if (consentIndex === -1) {
          tempAnswerList.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          tempAnswerList[consentIndex].answer = consentAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[consentQuestion?.key] = consentAnswer;

        // Update journey answers
        let consentjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === consentQuestion?.key,
        );
        if (consentjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: consentQuestion?.key,
            question: consentQuestion?.label,
            answer: consentAnswer,
          });
        } else {
          updatedJourneyAnswers[consentjourneyIndex].answer = consentAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === consentQuestion?.key) {
              item.answer = consentAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === consentQuestion?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = consentAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          consentQuestion,
          consentAnswer,
        );

        // Re-apply the state updates with BMI included
        setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
        setAnswerData(updatedAnswerData);
        setCompleteJourneyAnswers(updatedJourneyAnswers);
        setFormAnswer(tempFormAnswer);
        setFormSchema(tempFormAnswer?.form_schema?.formData);
        setJourneyData(updatedJourneyData);
      }
    }

    if (
      formData?.formId === "67f7cb7393a8e4fac0461c2e" &&
      (question?.key === "neckCircumferenceInches" ||
        question?.key === "gender" ||
        question?.key === "bmi")
    ) {
      if (
        question?.key === "neckCircumferenceInches" ||
        question?.key === "gender"
      ) {
        const gender =
          question?.key === "gender"
            ? answer?.value
            : updatedAnswerData?.gender?.value;
        const neckCircumferenceInches =
          question?.key === "neckCircumferenceInches"
            ? answer?.value
            : updatedAnswerData?.neckCircumferenceInches?.value;

        let cirmuferenceIsGreater = false;
        if (gender === "male" && parseFloat(neckCircumferenceInches) >= 17) {
          cirmuferenceIsGreater = true;
        }
        if (gender === "female" && parseFloat(neckCircumferenceInches) >= 15) {
          cirmuferenceIsGreater = true;
        }
        let qAnswer = null;
        if (cirmuferenceIsGreater) {
          qAnswer = { value: "Yes" };
        } else {
          qAnswer = { value: "No" };
        }
        const questionToUpdate = {
          label: "Is Neck Circumference > 17' (Men) or > 15' (Women)?",
          key: "isNeckCircumference17MenOr15Women",
          type: "radio",
        };
        let questionIndex = tempAnswerList.findIndex(
          (item) => item.key === questionToUpdate?.key,
        );
        if (questionIndex === -1) {
          tempAnswerList.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          tempAnswerList[questionIndex].answer = qAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[questionToUpdate?.key] = qAnswer;

        // Update journey answers
        let quesjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === questionToUpdate?.key,
        );
        if (quesjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === questionToUpdate?.key) {
              item.answer = qAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === questionToUpdate?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = qAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          questionToUpdate,
          qAnswer,
        );
      }
      if (question?.key === "bmi") {
        const bmiValue = answer?.value;
        let qAnswer = null;
        if (parseFloat(bmiValue) >= 30) {
          qAnswer = { value: "Yes" };
        } else {
          qAnswer = { value: "No" };
        }
        const questionToUpdate = {
          label: "Is BMI Greater than or Equal to 30?",
          key: "isBmiGreaterThanOrEqualTo30",
          type: "radio",
        };
        let questionIndex = tempAnswerList.findIndex(
          (item) => item.key === questionToUpdate?.key,
        );
        if (questionIndex === -1) {
          tempAnswerList.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          tempAnswerList[questionIndex].answer = qAnswer;
        }

        // Update updatedAnswerData
        updatedAnswerData[questionToUpdate?.key] = qAnswer;

        // Update journey answers
        let quesjourneyIndex = updatedJourneyAnswers.findIndex(
          (item) => item.key === questionToUpdate?.key,
        );
        if (quesjourneyIndex === -1) {
          updatedJourneyAnswers.push({
            key: questionToUpdate?.key,
            question: questionToUpdate?.label,
            answer: qAnswer,
          });
        } else {
          updatedJourneyAnswers[quesjourneyIndex].answer = qAnswer;
        }

        // Update form structure
        tempFormAnswer?.form_schema?.formData?.map((formPage) => {
          formPage?.content?.components.map((item) => {
            if (item?.key === questionToUpdate?.key) {
              item.answer = qAnswer;
              item.formValidation = true;
            }
          });
        });

        // Update journey data structure
        let activeFormPageIdForThisData = null;
        let activeFormIdForThisData = null;
        for (let i = 0; i < screens?.length; i++) {
          let screenPages = screens[i]?.screenPages;
          for (let j = 0; j < screenPages?.length; j++) {
            let form = screenPages[j]?.components?.form?.form_schema?.formData;
            for (let idx = 0; idx < form?.length; idx++) {
              let formContent = form[idx]?.content?.components;
              formContent?.map((ques) => {
                if (ques?.key === questionToUpdate?.key) {
                  activeFormPageIdForThisData = form[idx]?.id;
                  activeFormIdForThisData = screenPages[j]?.components?.formId;
                  ques.answer = qAnswer;
                  ques.formValidation = true;
                }
              });
            }
          }
        }

        // Add to trigger body
        addAnswerToTriggerBody(
          activeFormIdForThisData,
          activeFormPageIdForThisData,
          questionToUpdate,
          qAnswer,
        );
      }

      // Re-apply the state updates with BMI included
      setFormattedAnswer((prev) => ({ ...prev, answers: tempAnswerList }));
      setAnswerData(updatedAnswerData);
      setCompleteJourneyAnswers(updatedJourneyAnswers);
      setFormAnswer(tempFormAnswer);
      setFormSchema(tempFormAnswer?.form_schema?.formData);
      setJourneyData(updatedJourneyData);
    }
  };

  const handleBack = () => {
    const pagesToNavigate =
      theme === "alternaSleep" ? visibleFormPages : formSchema;

    for (let i = 0; i < pagesToNavigate.length; i++) {
      if (pagesToNavigate[i].id === activeFormPageId) {
        if (i > 0) {
          setActiveFormPage(pagesToNavigate[i - 1].content);
          setActiveFormPageId(pagesToNavigate[i - 1].id);
        } else {
          handleBackScreenPage();
        }
      }
    }
  };
  const handleNext = () => {
    let nextActionValid = true;
    const pagesToNavigate =
      theme === "alternaSleep" ? visibleFormPages : formSchema;

    for (let i = 0; i < pagesToNavigate.length; i++) {
      if (pagesToNavigate[i].id === activeFormPageId) {
        pagesToNavigate[i].content.components.map((questionData) => {
          // Handle columns component - recurse into nested components
          if (questionData.type === "columns") {
            // Answers for nested fields are stored on the parent columns component:
            // questionData.answer.value = { fieldKey: "fieldValue", ... }
            const parentAnswerValue = questionData?.answer?.value;
            if (questionData.columns && questionData.columns.length > 0) {
              questionData.columns.forEach((column) => {
                if (column.components && column.components.length > 0) {
                  column.components.forEach((nestedComponent) => {
                    if (
                      checkForQuestionToShow(nestedComponent) &&
                      nestedComponent?.validate?.required
                    ) {
                      const fieldValue = parentAnswerValue?.[nestedComponent.key];
                      const hasAnswer =
                        fieldValue !== undefined &&
                        fieldValue !== null &&
                        fieldValue !== "";
                      if (!hasAnswer) {
                        nestedComponent.formValidation = false;
                        questionData.formValidation = false;
                        nextActionValid = false;
                        setFormValidation(false);
                      }
                    }
                  });
                }
              });
            }
            return;
          }

          if (
            checkForQuestionToShow(questionData) &&
            questionData?.validate?.required &&
            !questionData?.answer
          ) {
            nextActionValid = false;
            setFormValidation(false);
          }
        });

        setActiveFormPage(pagesToNavigate[i].content);
      }
    }
    if (formData?.formId === "66ff55385b3a1419fb71ad79") {
      if (answerData?.doYouHaveMedicare?.value === "yes") {
        nextActionValid = false;
        setOpenModal(true);
        setModalTitle("Redirecting you to");
        setModalSubtitle("Synaptrx");
        setTimeout(() => {
          window.open(
            "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
            "_blank", // This specifies opening in a new tab
          );

          setOpenModal(false);
          setModalTitle("");
          setModalSubtitle("");
        }, 3000);
      }
    }

    if (formData?.formId === "66ff6e1e5b3a1419fb71b410") {
      if (answerData?.doYouHaveMedicare?.value === "yes") {
        nextActionValid = false;
        setOpenModal(true);
        setModalTitle("Redirecting you to");
        setModalSubtitle("Synaptrx");
        setTimeout(() => {
          window.open(
            "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
            "_blank", // This specifies opening in a new tab
          );

          setOpenModal(false);
          setModalTitle("");
          setModalSubtitle("");
        }, 3000);
      } else if (answerData?.doYouHaveMedicare?.value === "no") {
        if (answerData?.areYouUsingInsuranceForThisVisit?.value === "yes") {
          nextActionValid = false;
          setOpenModal(true);
          setModalTitle("Redirecting you to");
          setModalSubtitle("Synaptrx");
          setTimeout(() => {
            window.open(
              "https://schedule.yosicare.com/d6164e9e8d11921b63143e31ad61e4b3",
              "_blank", // This specifies opening in a new tab
            );
            setOpenModal(false);
            setModalTitle("");
            setModalSubtitle("");
          }, 3000);
        }
      }
    }

    if (
      formData?.formId === "66ec5b455b3a1419fb717b99" ||
      formData?.formId === "68525a6f4ef9cc55588fb84b" ||
      formData?.formId === "6819ad9dc4f18e73b7d06d38"
    ) {
      if (
        answerData?.iDontWantToAddMyCardOnFile &&
        answerData.iDontWantToAddMyCardOnFile?.value == true
      ) {
        nextActionValid = false;
        handleSubmit();
      }
    }

    if (nextActionValid) {
      for (let i = 0; i < pagesToNavigate.length; i++) {
        if (pagesToNavigate[i].id === activeFormPageId) {
          if (i < pagesToNavigate.length - 1) {
            setActiveFormPage(pagesToNavigate[i + 1].content);
            setActiveFormPageId(pagesToNavigate[i + 1].id);
            setFormValidation(true);
          }
        }
      }
    }
  };

  const handleSubmit = async () => {
    // Prevent submission if journey is read-only
    if (isJourneyReadOnly) {
      return;
    }

    // let tempFormAnswer = JSON.parse(JSON.stringify(formAnswer));
    let tempFormAnswer = deepCloneWithFiles(formAnswer);

    // let updatedJourneyData = JSON.parse(JSON.stringify(journeyData));
    let updatedJourneyData = deepCloneWithFiles(journeyData);

    let nextActionValid = true;

    for (let i = 0; i < formSchema.length; i++) {
      if (formSchema[i].id === activeFormPageId) {
        formSchema[i].content.components.map((questionData) => {
          // Enhanced validation logic while keeping your original structure
          const validateComponent = (component) => {
            // Reset validation state
            component.formValidation = true;

            // Skip hidden or conditionally invisible components — they must not block submission
            const isVisible = !component?.hidden && checkForQuestionToShow(component);
            if (!isVisible) return;

            // Handle columns component ALWAYS (regardless of parent required status)
            if (component.type === "columns") {
              if (component.columns && component.columns.length > 0) {
                component.columns.forEach((column) => {
                  if (column.components && column.components.length > 0) {
                    column.components.forEach((nestedComponent) => {
                      if (nestedComponent?.validate?.required) {
                        // Check if answer exists in nested component first
                        let hasNestedAnswer =
                          nestedComponent?.answer?.value &&
                          nestedComponent.answer.value !== "";

                        // If not, check if answer exists in parent column component
                        let hasParentAnswer = false;
                        if (!hasNestedAnswer && component?.answer?.value) {
                          const key = nestedComponent.key;
                          hasParentAnswer =
                            component.answer.value[key] &&
                            component.answer.value[key] !== "";
                        }

                        const isValid = hasNestedAnswer || hasParentAnswer;

                        if (!isValid) {
                          nestedComponent.formValidation = false;
                          component.formValidation = false;
                          nextActionValid = false;
                          setFormValidation(false);
                        }
                      }
                    });
                  }
                });
              }
              return; // Exit early for columns component
            }

            // For non-columns components, check if they are required
            if (component?.validate?.required) {
              let isValid = false;

              // Handle different component types
              switch (component.type) {
                case "textfield":
                case "textarea":
                case "email":
                  // Your original validation logic
                  isValid =
                    component?.answer &&
                    component.answer?.value &&
                    component.answer.value !== "";
                  break;

                case "select":
                case "radio":
                  // For select/radio components
                  isValid =
                    component?.answer &&
                    component.answer?.value &&
                    component.answer.value !== "";
                  break;

                case "checkbox":
                  // For checkboxes
                  if (component.multiple) {
                    isValid =
                      component?.answer?.value &&
                      Array.isArray(component.answer.value) &&
                      component.answer.value.length > 0;
                  } else {
                    isValid = Boolean(component?.answer?.value);
                  }
                  break;

                case "file":
                  // For file uploads
                  isValid =
                    component?.answer?.value &&
                    (Array.isArray(component.answer.value)
                      ? component.answer.value.length > 0
                      : Boolean(component.answer.value));
                  break;

                case "datetime":
                  // For date/time components
                  isValid =
                    component?.answer &&
                    component.answer?.value &&
                    component.answer.value !== "";
                  break;

                case "content":
                case "button":
                  // Content and button components don't need validation
                  isValid = true;
                  break;

                default:
                  // Your original logic for all other types
                  isValid =
                    component?.answer &&
                    component.answer?.value &&
                    component.answer.value !== "";
              }

              if (!isValid) {
                component.formValidation = false;
                nextActionValid = false;
                setFormValidation(false);
              }
            }
          };

          // Apply validation to the component
          validateComponent(questionData);
        });

        setActiveFormPage(formSchema[i].content);
      }
    }

    if (journeyInstanceId && !isJourneyReadOnly) {
      const response = updateJourneyDataForInstanceId(journeyInstanceId, {
        journey_schema: updatedJourneyData?.journey_schema,
        status: "IN_PROGRESS",
      });
    }

    if (nextActionValid) {
      newFormSubmit(formattedAnswer, formData?.form?.org);
      newFormSubmitForTriggers(
        tempFormAnswer,
        formData?.form?._id,
        formTriggers,
      );
      setShowLoader(true); // Show loader before starting workflow checks
      setLoaderMessage("Compiling data...");
      // let workflowCompletion = await triggerAttachedWorkflows();
      setShowLoader(false); // Hide loader after completion
      setLoaderMessage("");

      // workflowCompletion && handleNextScreenPage();
      handleNextScreenPage(updatedJourneyData);
    }
  };

  const getTriggerUrl = async (triggerId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    // const triggerAPIUrl = `${API_URL}/api/v1/webhooks/${triggerId}`;
    const triggerAPIUrl = `${API_URL}/api/v1/webhooks/open/formSubmission/${triggerId}`;
    const response = await axios.get(triggerAPIUrl);
    if (response && response.data) {
      return response.data.url;
    }
    return null;
  };

  const triggerAttachedWorkflows = async () => {
    const formId = formData?.formId;
    let workflowInstances = [];

    if (formTriggers.triggers.length > 0) {
      // Use the correct trigger body based on configuration
      let triggerBody = {
        journeyData: formTriggers.singleFormBody
          ? { [formId]: qnABodyForTriggers[formId] }
          : qnABodyForTriggers,
        appointmentHash: hashIdFromQP || null,
      };
      if (!triggerBody) {
        triggerBody = {}; // Provide a default empty object or appropriate default
      }

      // Trigger all workflows
      for (let i = 0; i < formTriggers.triggers.length; i++) {
        let trigger = formTriggers.triggers[i];
        let triggerUrl = await getTriggerUrl(trigger);

        if (triggerUrl) {
          try {
            let response = await axios.post(triggerUrl, triggerBody);
            if (response?.data?.workflowInstances) {
              workflowInstances = [
                ...workflowInstances,
                ...response.data.workflowInstances,
              ];
            }
          } catch (error) {
            if (error.response) {
              console.error("Response data:", error.response.data);
              console.error("Response status:", error.response.status);
            }
            return false; // Return false if any trigger fails
          }
        }
      }
    }

    // If we don't need to wait for workflow completion, return true immediately
    if (!formTriggers.waitForWorkflowCompletion) {
      return true;
    }

    // Otherwise, poll for completion status of all workflow instances
    return await checkAllWorkflowsCompletion(workflowInstances);
  };

  const checkAllWorkflowsCompletion = async (instanceIds) => {
    if (!instanceIds.length) return true;

    const MAX_ATTEMPTS = 20; // Maximum 3 minutes (60 * 3 seconds)
    let attempts = 0;

    // Keep checking until we reach max attempts
    while (attempts < MAX_ATTEMPTS) {
      let allCompleted = true;
      let anyFailed = false;

      // Check status of each workflow instance
      for (let instanceId of instanceIds) {
        const status = await checkWorkflowCompletion(instanceId);

        if (status === "FAILED") {
          anyFailed = true;
          break; // Exit early if any workflow fails
        } else if (status !== "SUCCESS") {
          allCompleted = false; // Not all are completed yet
        }
      }

      // If any failed, return false
      if (anyFailed) {
        return false;
      }

      // If all completed successfully, return true
      if (allCompleted) {
        return true;
      }

      // Wait for 3 seconds before next check
      await new Promise((resolve) => setTimeout(resolve, 3000));
      attempts++;
    }

    // If we reached max attempts without all completing successfully,
    // we consider it a timeout failure
    console.error("Workflow completion check timed out after 1 minutes");
    return false;
  };

  const checkWorkflowCompletion = async (instanceId) => {
    const API_URL = process.env.REACT_APP_WORKFLOW_BACKEND_URL;
    const workflowAPIUrl = `${API_URL}/api/v1/workflow-instances/${instanceId}`;

    try {
      const response = await axios.get(workflowAPIUrl);
      if (response?.data) {
        return response.data.status; // Returns one of: PENDING, FAILED, RUNNING, PAUSED, SUCCESS
      }
    } catch (error) {
      console.error(`Error checking workflow status for ${instanceId}:`, error);
      return "FAILED"; // Consider API errors as failures
    }

    return "PENDING"; // Default to PENDING if no valid response
  };

  const checkForQuestionToShow = (ques) => {
    let show = true;
    if (ques?.conditional && ques.conditional?.eq && ques.conditional?.when) {
      show = !ques.conditional?.show;
      let journeyAnswerIndex = completeJourneyAnswers.findIndex(
        (item) => item.key === ques.conditional.when,
      );
      let answer = completeJourneyAnswers[journeyAnswerIndex]?.answer?.value;
      if (
        (typeof answer === "string" && answer === ques.conditional?.eq) ||
        (Array.isArray(answer) && answer.includes(ques.conditional?.eq)) ||
        (Array.isArray(ques.conditional?.eq) &&
          typeof answer === "string" &&
          ques.conditional?.eq.includes(answer)) ||
        (typeof answer === "boolean" && answer == ques.conditional?.eq) ||
        (typeof answer === "object" &&
          answer !== null &&
          !Array.isArray(answer) &&
          // Check if conditional.eq is a key in the answer object and it's true
          ((typeof ques.conditional?.eq === "string" &&
            answer[ques.conditional.eq] === true) ||
            // Check if conditional.eq is an array and any of its values are keys with true values
            (Array.isArray(ques.conditional?.eq) &&
              ques.conditional.eq.some((key) => answer[key] === true))))
      ) {
        show = ques.conditional?.show || false;
      }
    }
    return show;
  };

  const checkForPageToShow = (page) => {
    let show = true;
    if (page?.conditional && page.conditional?.eq && page.conditional?.when) {
      show = !page.conditional?.show;
      let journeyAnswerIndex = completeJourneyAnswers.findIndex(
        (item) => item.key === page.conditional.when,
      );
      let answer = completeJourneyAnswers[journeyAnswerIndex]?.answer?.value;
      if (
        (typeof answer === "string" && answer === page.conditional?.eq) ||
        (Array.isArray(answer) && answer.includes(page.conditional?.eq)) ||
        (Array.isArray(page.conditional?.eq) &&
          typeof answer === "string" &&
          page.conditional?.eq.includes(answer)) ||
        (typeof answer === "boolean" && answer == page.conditional?.eq) ||
        (typeof answer === "object" &&
          answer !== null &&
          !Array.isArray(answer) &&
          ((typeof page.conditional?.eq === "string" &&
            answer[page.conditional?.eq] === true) ||
            (Array.isArray(page.conditional?.eq) &&
              page.conditional.eq.some((key) => answer[key] === true))))
      ) {
        show = page.conditional?.show || false;
      }
    }
    return show;
  };

  const visibleFormPages = useMemo(() => {
    if (theme !== "alternaSleep" || !Array.isArray(formSchema)) {
      return formSchema || [];
    }

    return formSchema.filter((page) => checkForPageToShow(page));
  }, [formSchema, completeJourneyAnswers, theme]);

  const currentVisiblePageIndex = useMemo(() => {
    if (!Array.isArray(visibleFormPages) || !activeFormPageId) return -1;

    return visibleFormPages.findIndex((page) => page?.id === activeFormPageId);
  }, [visibleFormPages, activeFormPageId]);

  const getComponentAnswerValue = (component, parentAnswerValue = null) => {
    if (!component?.key) return undefined;

    if (
      parentAnswerValue &&
      typeof parentAnswerValue === "object" &&
      !Array.isArray(parentAnswerValue) &&
      Object.prototype.hasOwnProperty.call(parentAnswerValue, component.key)
    ) {
      return parentAnswerValue[component.key];
    }

    return component?.answer?.value ?? answerData?.[component.key]?.value;
  };

  const hasNonEmptyValue = (value) => {
    if (value === undefined || value === null) return false;

    if (typeof value === "string") {
      return value.trim() !== "";
    }

    if (Array.isArray(value)) {
      return value.length > 0;
    }

    if (typeof value === "object") {
      if (value instanceof File) return true;

      // Support Moment/Date-like values used by date picker components
      if (value?.$d instanceof Date) return !isNaN(value.$d.getTime());
      if (value instanceof Date) return !isNaN(value.getTime());

      const objectValues = Object.values(value);
      if (!objectValues.length) return false;

      // Support selectboxes style answer object: { optionA: true, optionB: false }
      const allBooleanValues = objectValues.every(
        (item) => typeof item === "boolean",
      );
      if (allBooleanValues) {
        return objectValues.some((item) => item === true);
      }

      // Support rich datetime/date objects (e.g. { isoString, dateObj, ... })
      // and other non-empty object answers.
      return objectValues.some((item) => {
        if (item === undefined || item === null) return false;
        if (typeof item === "string") return item.trim() !== "";
        if (Array.isArray(item)) return item.length > 0;
        if (item instanceof Date) return !isNaN(item.getTime());
        if (typeof item === "number") return !isNaN(item);
        return true;
      });
    }

    if (typeof value === "number") {
      return !isNaN(value);
    }

    if (typeof value === "boolean") {
      return value;
    }

    return Boolean(value);
  };

  const isRequiredComponentValid = (
    component,
    parentAnswerValue = null,
  ) => {
    if (!component) return true;

    const isVisible = !component?.hidden && checkForQuestionToShow(component);
    if (!isVisible) {
      // Hidden due to conditional/visibility rules should pass required validation.
      return true;
    }

    if (component?.type === "columns") {
      if (!Array.isArray(component?.columns)) return true;
      const columnsAnswerValue = component?.answer?.value;

      return component.columns.every((column) => {
        if (!Array.isArray(column?.components)) return true;
        return column.components.every((nestedComponent) =>
          isRequiredComponentValid(nestedComponent, columnsAnswerValue),
        );
      });
    }

    if (component?.type === "fieldset") {
      if (!Array.isArray(component?.components)) return true;
      return component.components.every((nestedComponent) =>
        isRequiredComponentValid(nestedComponent),
      );
    }

    if (!component?.validate?.required) {
      return true;
    }

    const answerValue = getComponentAnswerValue(component, parentAnswerValue);

    if (component?.type === "checkbox") {
      return component?.multiple
        ? Array.isArray(answerValue) && answerValue.length > 0
        : answerValue === true;
    }

    if (component?.type === "selectboxes") {
      if (Array.isArray(answerValue)) {
        return answerValue.length > 0;
      }
      if (
        answerValue &&
        typeof answerValue === "object" &&
        !Array.isArray(answerValue)
      ) {
        return Object.values(answerValue).some((value) => value === true);
      }
      return false;
    }

    if (component?.type === "file") {
      if (Array.isArray(answerValue)) return answerValue.length > 0;
      if (answerValue instanceof File) return true;
      return hasNonEmptyValue(answerValue);
    }

    return hasNonEmptyValue(answerValue);
  };

  const isCurrentPageRequiredFieldsValid = useMemo(() => {
    if (!Array.isArray(formSchema) || !activeFormPageId) return true;

    const currentPage = formSchema.find((page) => page?.id === activeFormPageId);
    if (!currentPage?.content?.components) return true;

    return currentPage.content.components.every((component) =>
      isRequiredComponentValid(component),
    );
  }, [formSchema, activeFormPageId, answerData, completeJourneyAnswers]);

  const getSelectedValuesFromAnswer = (answerValue, componentValues = []) => {
    if (answerValue === undefined || answerValue === null || answerValue === "") {
      return [];
    }

    const orderedOptionValues = Array.isArray(componentValues)
      ? componentValues
          .map((option) => option?.value)
          .filter((value) => value !== undefined && value !== null)
      : [];

    const sortByOptionOrder = (values) => {
      if (!orderedOptionValues.length) return values;

      const orderMap = new Map(
        orderedOptionValues.map((value, index) => [String(value), index]),
      );

      return [...values].sort((a, b) => {
        const aOrder = orderMap.has(String(a))
          ? orderMap.get(String(a))
          : Number.MAX_SAFE_INTEGER;
        const bOrder = orderMap.has(String(b))
          ? orderMap.get(String(b))
          : Number.MAX_SAFE_INTEGER;
        return aOrder - bOrder;
      });
    };

    if (Array.isArray(answerValue)) {
      const filteredValues = answerValue.filter(
        (value) => value !== undefined && value !== null,
      );
      return sortByOptionOrder(filteredValues);
    }

    if (typeof answerValue === "object") {
      const selectedKeys = Object.keys(answerValue).filter(
        (key) => answerValue[key] === true,
      );
      return sortByOptionOrder(selectedKeys);
    }

    return [answerValue];
  };

  const extractDescriptionHtml = (descriptionConfig) => {
    if (!descriptionConfig) return null;
    if (typeof descriptionConfig === "string") return descriptionConfig;
    if (typeof descriptionConfig === "object") {
      return (
        descriptionConfig.html ||
        descriptionConfig.description ||
        descriptionConfig.content ||
        null
      );
    }
    return null;
  };

  const getDescriptionHtmlBySelectedValue = (descriptionConfig, selectedValue) => {
    if (!descriptionConfig) return null;

    if (Array.isArray(descriptionConfig)) {
      const matchedRule = descriptionConfig.find((rule) => {
        if (!rule || typeof rule !== "object") return false;
        if (Array.isArray(rule.value)) {
          return rule.value.includes(selectedValue);
        }
        return rule.value === selectedValue;
      });
      return extractDescriptionHtml(matchedRule);
    }

    if (typeof descriptionConfig === "object") {
      const byExactValue = descriptionConfig[selectedValue];
      const byStringValue = descriptionConfig[String(selectedValue)];
      const byDefault = descriptionConfig.default;
      return (
        extractDescriptionHtml(byExactValue) ||
        extractDescriptionHtml(byStringValue) ||
        extractDescriptionHtml(byDefault)
      );
    }

    return null;
  };

  const answerDescriptionBlocks = useMemo(() => {
    if (!activeFormPage?.components || !Array.isArray(activeFormPage.components)) {
      return [];
    }

    const blocks = [];

    activeFormPage.components.forEach((component, index) => {
      const shouldShow = checkForQuestionToShow(component) && !component?.hidden;
      if (!shouldShow) return;

      // Static description: always visible when component is shown, no answer required.
      const staticHtml = component?.staticDescription;
      if (staticHtml && typeof staticHtml === "string") {
        blocks.push({
          id: `${component?.key || "component"}-static-${index}`,
          html: staticHtml,
        });
      }

      const descriptionConfig =
        component?.answerDescriptions ||
        component?.answerDescriptionMap ||
        null;

      const answerValue = component?.answer?.value ?? answerData?.[component?.key]?.value;
      const selectedValues = getSelectedValuesFromAnswer(
        answerValue,
        component?.values,
      );

      selectedValues.forEach((selectedValue) => {
        let html = getDescriptionHtmlBySelectedValue(descriptionConfig, selectedValue);

        // Fallback to option-level description fields if mapping is not provided.
        if (!html && Array.isArray(component?.values)) {
          const selectedOption = component.values.find(
            (option) => option?.value === selectedValue,
          );
          html =
            selectedOption?.answerDescriptionHtml ||
            selectedOption?.answerDescription ||
            selectedOption?.descriptionHtml ||
            null;
        }

        if (html && typeof html === "string") {
          blocks.push({
            id: `${component?.key || "component"}-${selectedValue}-${index}`,
            html,
          });
        }
      });
    });

    // Page-level aggregated descriptions: rules across multiple questions.
    const aggregatedRulesets = activeFormPage?.aggregatedDescriptions || [];
    const conditionPriority = {
      mixed: 5,
      all: 4,
      any: 3,
      none: 2,
      default: 1,
    };

    const doesAggregatedRuleMatch = (rule, answers, answeredValues) => {
      const { condition, value } = rule || {};
      const exceptionValues = [];

      if (Array.isArray(rule?.exceptionValues)) {
        exceptionValues.push(...rule.exceptionValues.map((v) => String(v)));
      }

      if (rule?.exceptionValue !== undefined) {
        exceptionValues.push(String(rule.exceptionValue));
      }

      const filteredAnsweredValues = exceptionValues.length
        ? answeredValues.filter((a) => !exceptionValues.includes(a))
        : answeredValues;

      if (!filteredAnsweredValues.length && condition !== "default") {
        return false;
      }

      if (condition === "all" && value !== undefined) {
        // Match when all currently answered values are the same target value.
        return filteredAnsweredValues.every((a) => a === String(value));
      }

      if (condition === "none" && value !== undefined) {
        return filteredAnsweredValues.every((a) => a !== String(value));
      }

      if (condition === "any" && value !== undefined) {
        return filteredAnsweredValues.some((a) => a === String(value));
      }

      if (condition === "mixed") {
        // If rule.values is provided, only those values participate in mixed calculation.
        const mixedScope = Array.isArray(rule?.values)
          ? rule.values.map((v) => String(v))
          : [];
        const scopedValues = mixedScope.length
          ? filteredAnsweredValues.filter((a) => mixedScope.includes(a))
          : filteredAnsweredValues;

        return scopedValues.length > 1 && new Set(scopedValues).size > 1;
      }

      if (condition === "default") {
        return true;
      }

      return false;
    };

    aggregatedRulesets.forEach((ruleset, rulesetIndex) => {
      const questionKeys = ruleset?.questions || [];
      if (!questionKeys.length) return;

      const answers = questionKeys.map((key) => {
        const component = activeFormPage.components.find((c) => c?.key === key);
        const val = component?.answer?.value ?? answerData?.[key]?.value;
        return val !== undefined && val !== null && val !== "" ? String(val) : null;
      });

      const answeredValues = answers.filter((a) => a !== null);
      if (!answeredValues.length) return;

      const matchedRules = (ruleset?.rules || [])
        .map((rule, index) => ({ rule, index }))
        .filter(({ rule }) => {
          if (!rule?.html || typeof rule.html !== "string") return false;
          return doesAggregatedRuleMatch(rule, answers, answeredValues);
        });

      if (!matchedRules.length) return;

      matchedRules.sort((a, b) => {
        const aPriority = conditionPriority[a.rule?.condition] || 0;
        const bPriority = conditionPriority[b.rule?.condition] || 0;
        if (aPriority !== bPriority) return bPriority - aPriority;
        return a.index - b.index;
      });

      blocks.push({
        id: `aggregated-${rulesetIndex}`,
        html: matchedRules[0].rule.html,
      });
    });

    return blocks;
  }, [activeFormPage, answerData, completeJourneyAnswers]);

  const firstVisibleButtonIndex = useMemo(() => {
    if (!activeFormPage?.components || !Array.isArray(activeFormPage.components)) {
      return -1;
    }

    return activeFormPage.components.findIndex(
      (component) =>
        component?.type === "button" &&
        checkForQuestionToShow(component) &&
        !component?.hidden,
    );
  }, [activeFormPage, completeJourneyAnswers]);

  useEffect(() => {
    if (formData) {
      setFormattedAnswer({
        type: formData?.type,
        formId: formData.formId,
        answers: [],
      });
      fetchFormSchema(formData);
      callAthenaAPIs();
    }
    function checkPatientDepartmentKey(formSchemaData, targetKey) {
      // Check if formData exists and is an array
      if (
        !formSchemaData.form_schema ||
        !formSchemaData.form_schema.formData ||
        !Array.isArray(formSchemaData.form_schema.formData)
      ) {
        return {
          exists: false,
          message: "Invalid form schema structure",
        };
      }

      // Iterate through each form page
      for (const page of formSchemaData.form_schema.formData) {
        // Check if the page has content and components
        if (
          page.content &&
          page.content.components &&
          Array.isArray(page.content.components)
        ) {
          // Search through components for the target key
          for (const component of page.content.components) {
            if (component.key === targetKey) {
              return component.answer ? component.answer.value : null;
            }
          }
        }
      }

      // Key not found
      return null;
    }
    if (
      formData?.formId === "6819ab3ec4f18e73b7d06d0e" ||
      formData?.formId === "66fe0d935b3a1419fb71a96d" ||
      formData?.formId === "686b682dc92b0a640c372127" ||
      formData?.formId === "685259b64ef9cc55588fb849"
    ) {
      fetchAllDepartments();
      if (formData?.form) {
        const departmentId = checkPatientDepartmentKey(
          formData?.form,
          "patientDepartmentForSchedulerForSpecificForm",
        );
        departmentId && fetchAllReasons(departmentId);
      }
    }
  }, [formData]);

  const fetchAllDepartments = async () => {
    setShowLoader(true);
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    // hardcoded scheduler id for now, will make it dynamic during journey refactor. 67500bf9f24586aa9894a48c
    let allDepartmentsAPIUrl = "";
    if (formData?.formId === "6819ab3ec4f18e73b7d06d0e")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/6818e400362163c857cee438/departments`;
    if (formData?.formId === "66fe0d935b3a1419fb71a96d")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/67d8416ea9a925a0cd064b3c/departments`;
    if (formData?.formId === "686b682dc92b0a640c372127")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/67d8416ea9a925a0cd064b3c/departments`;
    if (formData?.formId === "685259b64ef9cc55588fb849")
      allDepartmentsAPIUrl = `${API_URL}/api/v1/providers/685258257141029067a64e30/departments`;
    const response = await axios.get(allDepartmentsAPIUrl);

    if (response && response.data) {
      const allDepartments = response.data?.HBx?.departments?.map((item) => {
        return {
          ...item,
          label: item?.name,
          value: item?.departmentId,
        };
      });
      setAllDepartmentsForSpecificForm(allDepartments);
    }
    setShowLoader(false);
  };
  const fetchAllReasons = async (department_id) => {
    const API_URL = process.env.REACT_APP_SCHEDULER_URL;
    // hardcoded scheduler id for now, will make it dynamic during journey refactor
    let allReasonsAPIUrl = "";
    if (formData?.formId === "6819ab3ec4f18e73b7d06d0e")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/6818e400362163c857cee438/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "66fe0d935b3a1419fb71a96d")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/67d8416ea9a925a0cd064b3c/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "686b682dc92b0a640c372127")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/67d8416ea9a925a0cd064b3c/reasons?departmentId=${department_id}&providerId=-1`;
    if (formData?.formId === "685259b64ef9cc55588fb849")
      allReasonsAPIUrl = `${API_URL}/api/v1/appointments/685258257141029067a64e30/reasons?departmentId=${department_id}&providerId=-1`;

    const response = await axios.get(allReasonsAPIUrl);

    if (response && response.data) {
      const allReasons = response.data?.HBx?.patientappointmentreasons?.map(
        (item) => {
          return {
            ...item,
            label: item?.reason,
            value: item?.reasonid,
            Description: item?.description,
          };
        },
      );
      setAllReasonsForSpecificForm(allReasons);
    }
  };

  useEffect(() => {
    setActiveFormPage(activeFormPageData?.content);
    setActiveFormPageId(activeFormPageData?.id);
    // window.scrollTo(0, 0); // Scroll to top when form page changes
  }, [activeFormPageData]);

  useEffect(() => {
    // window.scrollTo(0, 0); // Scroll to top when form page changes
  }, [activeFormPageId]);

  // Extract form page steps for progress tracker
  useEffect(() => {
    if (theme === "alternaSleep" && formSchema) {
      const steps = visibleFormPages.map((page) => page.label || "Step");
      setFormPageSteps(steps);

      // Find the current step index
      const currentIndex = currentVisiblePageIndex;
      if (currentIndex !== -1) {
        setCurrentStepIndex(currentIndex);
      }
    }
  }, [
    formSchema,
    activeFormPageId,
    theme,
    visibleFormPages,
    currentVisiblePageIndex,
  ]);

  const handleContainerKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default action on pressing Enter
    }
  };

  return (
    <div
      className="w-auto form-renderer-new"
      onKeyDown={handleContainerKeyDown}
    >
      {theme === "alternaSleep" && (
        <div
          className="alternasleep-header-container"
          style={{ position: "relative", zIndex: 10 }}
        >
          {/* Form Header Title and Subtitle for alternaSleep theme 
              This renders at component level and persists across all form pages */}
          {formData?.form?.form_schema?.formMetaData && (
            <div className="w-full px-3 md:px-6 lg:px-8 pt-8">
              {/* Form Header Title */}
              {formData.form.form_schema.formMetaData.formHeaderTitle && (
                <div
                  className="form-header-title mb-6"
                  dangerouslySetInnerHTML={{
                    __html:
                      formData.form.form_schema.formMetaData.formHeaderTitle
                        .html,
                  }}
                />
              )}

              {/* Form Header Subtitle */}
              {formData.form.form_schema.formMetaData.formHeaderSubtitle && (
                <div
                  className="form-header-subtitle"
                  style={{ marginBottom: "32px" }}
                  dangerouslySetInnerHTML={{
                    __html:
                      formData.form.form_schema.formMetaData.formHeaderSubtitle
                        .html,
                  }}
                />
              )}
            </div>
          )}

          {/* Progress Tracker for alternaSleep theme 
              Updates based on currentStepIndex as user navigates through pages */}
          {formPageSteps.length > 1 && (
            <div
              className="w-full px-3 md:px-6 lg:px-8"
              style={{ position: "relative", zIndex: 9 }}
            >
              <AlternaSleepProgressTracker
                steps={formPageSteps}
                currentStep={currentStepIndex}
                isReadOnly={isJourneyReadOnly}
              />
            </div>
          )}
        </div>
      )}

      <div
        className="w-auto px-3 md:px-6 lg:px-8 pb-8"
        style={{ position: "relative", zIndex: 1 }}
      >
        {showloader ? (
          <div className=" flex flex col min-h-96 justify-center items-center">
            <Loader message={loaderMessage} />
          </div>
        ) : (
          <>
            {(formData?.formId === insuranceForm ||
              formData?.formId === "68525b174ef9cc55588fb84e" ||
              formData?.formId === insuranceFormProd) &&
            insuranceCollectedStatus ? (
              <div className="content-width">
                <div className="flex flex-col">
                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                    Insurance Collected for this Checkin
                  </div>
                </div>
              </div>
            ) : (formData?.formId === paymentForm ||
                formData?.formId === "68525a6f4ef9cc55588fb84b" ||
                formData?.formId === paymentFormProd) &&
              paymentCollectedStatus ? (
              <div className="content-width">
                <div className="flex flex-col">
                  <div className="text-center font-semibold text-lg py-3 shadow my-5 px-24 rounded bg-gray-100">
                    Payment Details Collected for this Checkin
                  </div>
                </div>
              </div>
            ) : (
              <>
                {activeFormPage &&
                  activeFormPage?.components &&
                  activeFormPage?.components?.map((item, index) => {
                    // First check if we should show this question at all

                    const shouldShow =
                      checkForQuestionToShow(item) && !item?.hidden;
                    const isConditional =
                      item?.conditional &&
                      item.conditional?.eq &&
                      item.conditional?.when;

                    const isSelectBoxes = item?.type === "selectboxes";

                    // if (!checkForQuestionToShow(item)) {
                    //   return null;
                    // }
                    if (!isConditional && !shouldShow) {
                      return null;
                    }

                    // Then render the appropriate component based on type
                    let FormComponent = null;
                    let specialProps = {};

                    switch (item?.type) {
                      case "textfield":
                        FormComponent = TextField;
                        break;
                      case "heightField":
                        FormComponent = HeightField;
                        break;
                      case "americanPhoneField":
                        FormComponent = AmericanPhoneField;
                        break;
                      case "textarea":
                        FormComponent = TextArea;
                        specialProps = { data: { ...item, disabled: isJourneyReadOnly } };
                        break;
                      case "password":
                        FormComponent = Password;
                        break;
                      case "datetime":
                        FormComponent = DateInput;
                        break;
                      case "dob":
                        FormComponent = DateInput;
                        break;
                      case "email":
                        FormComponent = EmailField;
                        break;
                      case "checkbox":
                        FormComponent = SingleCheckBox;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "select":
                        FormComponent = DropDownSelector;

                        // Special case for department selector
                        if (
                          item?.key ===
                          "patientDepartmentForSchedulerForSpecificForm"
                        ) {
                          specialProps = {
                            data: {
                              ...item,
                              data: { values: allDepartmentsForSpecificForm },
                            },
                          };
                        }
                        break;
                      case "number":
                        FormComponent = NumberInput;
                        break;
                      case "phoneNumber":
                        FormComponent = PhoneField;
                        break;
                      case "dropDownWithSearch":
                        FormComponent = DropDownWithSearch;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "radio":
                        FormComponent = RadioSelector;
                        // Special case for reason selector
                        if (item?.key === "reasonForVisitForScheduler") {
                          specialProps = {
                            data: {
                              ...item,
                              values: allReasonsForSpecificForm,
                            },
                          };
                        }
                        break;
                      case "content":
                        FormComponent = Content;
                        break;
                      case "datagrid":
                        FormComponent = DataGrid;
                        specialProps = {
                          allDepartmentsForSpecificForm,
                          allReasonsForSpecificForm,
                        };
                        break;
                      case "columns":
                        FormComponent = Columns;
                        specialProps = {
                          allDepartmentsForSpecificForm,
                          allReasonsForSpecificForm,
                        };
                        break;
                      case "fieldset":
                        // Transform fieldset into a single full-width column for Columns component
                        specialProps = {
                          allDepartmentsForSpecificForm,
                          allReasonsForSpecificForm,
                          data: {
                            ...item,
                            label: item.legend || item.label,
                            columns: [{
                              components: item.components,
                              width: 12,
                              size: "md",
                              offset: 0,
                            }],
                          },
                        };
                        FormComponent = Columns;
                        break;
                      case "file":
                        FormComponent = UploadFile;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "selectboxes":
                        FormComponent = CheckBoxSelector;
                        // specialProps = { formValidation: item?.formValidation };
                        break;
                      case "dynamicContentRenderer":
                        FormComponent = DynamicContentRenderer;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "healthHistoryAllergyComponent":
                        FormComponent = HealthHistoryAllergyComponent;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "healthHistoryMedicationComponent":
                        FormComponent = HealthHistoryMedicationComponent;
                        specialProps = { formValidation: item?.formValidation };
                        break;
                      case "button":
                        // Custom button logic for alternaSleep theme
                        if (theme === "alternaSleep") {
                          FormComponent = ({ data }) => {
                            const currentPageIndex = currentVisiblePageIndex;
                            const isFirstPage = currentPageIndex === 0;
                            const isLastPage =
                              currentPageIndex === visibleFormPages.length - 1;

                            // Get button labels from config or use defaults
                            const previousLabel =
                              data?.customLabels?.previous ||
                              data?.previousLabel ||
                              "Previous";
                            const continueLabel =
                              data?.customLabels?.continue ||
                              data?.continueLabel ||
                              "Continue";
                            const submitLabel =
                              data?.customLabels?.submit ||
                              data?.submitLabel ||
                              data?.label ||
                              "Submit";

                            const isContinueDisabled =
                              showloader ||
                              data?.disableContinue ||
                              !isCurrentPageRequiredFieldsValid ||
                              isJourneyReadOnly;

                            const isSubmitDisabled =
                              showloader ||
                              data?.disableSubmit ||
                              (data?.disableOnInvalid && !formValid) ||
                              !isCurrentPageRequiredFieldsValid ||
                              isJourneyReadOnly;

                            // Custom action handler
                            const handleButtonClick = async (actionType) => {
                              if (showloader) return;

                              try {
                                // Execute beforeAction callback if configured
                                if (
                                  data?.beforeAction &&
                                  typeof data.beforeAction === "function"
                                ) {
                                  const shouldContinue =
                                    await data.beforeAction(
                                      actionType,
                                      answerData,
                                      formattedAnswer,
                                    );
                                  if (shouldContinue === false) return;
                                }

                                // Handle custom actions based on configuration
                                if (
                                  data?.customAction &&
                                  actionType === "submit"
                                ) {
                                  const {
                                    type,
                                    url,
                                    openInNewTab,
                                    functionName,
                                    params,
                                    executeBeforeSubmit,
                                  } = data.customAction;

                                  // Execute custom function if configured
                                  if (type === "function" && functionName) {
                                    if (
                                      window[functionName] &&
                                      typeof window[functionName] === "function"
                                    ) {
                                      await window[functionName]({
                                        ...params,
                                        formData: answerData,
                                        answers: formattedAnswer,
                                        actionType,
                                      });
                                    } else {
                                      console.warn(
                                        `Custom function "${functionName}" not found on window object`,
                                      );
                                    }
                                  }

                                  // Handle redirect before submit
                                  if (
                                    type === "redirect" &&
                                    url &&
                                    executeBeforeSubmit
                                  ) {
                                    if (openInNewTab) {
                                      window.open(url, "_blank");
                                    } else {
                                      window.location.href = url;
                                      return; // Stop execution if redirecting in same tab
                                    }
                                  }

                                  // Execute form submit
                                  await handleSubmit();

                                  // Handle redirect after submit
                                  if (
                                    type === "redirect" &&
                                    url &&
                                    !executeBeforeSubmit
                                  ) {
                                    setTimeout(() => {
                                      if (openInNewTab) {
                                        window.open(url, "_blank");
                                      } else {
                                        window.location.href = url;
                                      }
                                    }, data?.redirectDelay || 500);
                                    return;
                                  }

                                  return;
                                }

                                // Handle simple redirect configurations (backward compatibility)
                                if (
                                  data?.redirectOnSubmit &&
                                  actionType === "submit"
                                ) {
                                  await handleSubmit();
                                  setTimeout(() => {
                                    if (data?.openInNewTab) {
                                      window.open(
                                        data.redirectOnSubmit,
                                        "_blank",
                                      );
                                    } else {
                                      window.location.href =
                                        data.redirectOnSubmit;
                                    }
                                  }, data?.redirectDelay || 500);
                                  return;
                                }

                                // Default actions
                                if (actionType === "back") {
                                  handleBack();
                                } else if (actionType === "next") {
                                  // Reset validation state before checking
                                  setFormValidation(true);
                                  handleNext();
                                } else if (actionType === "submit") {
                                  await handleSubmit();
                                }

                                // Execute afterAction callback if configured
                                if (
                                  data?.afterAction &&
                                  typeof data.afterAction === "function"
                                ) {
                                  await data.afterAction(
                                    actionType,
                                    answerData,
                                    formattedAnswer,
                                  );
                                }
                              } catch (error) {
                                console.error("Button action error:", error);
                                // Execute error handler if configured
                                if (
                                  data?.onError &&
                                  typeof data.onError === "function"
                                ) {
                                  data.onError(error, actionType);
                                }
                              }
                            };

                            return (
                              <div className="py-4 flex flex-col md:flex-row-reverse justify-center gap-3 md:gap-4 w-full">
                                {/* Show Continue button if NOT last page */}
                                {!isLastPage && !data?.hideContinue && (
                                  <button
                                    onClick={() => {
                                      if (!isContinueDisabled) {
                                        handleButtonClick("next");
                                      }
                                    }}
                                    className={`w-full md:w-auto ${
                                      data?.continueClassName ||
                                      "alterna-btn-primary"
                                    }`}
                                    disabled={isContinueDisabled}
                                  >
                                    {continueLabel}
                                  </button>
                                )}
                                 {/* Show Submit button if last page */}
                                {isLastPage && !data?.hideSubmit && (
                                  <button
                                    onClick={() => {
                                      if (!isSubmitDisabled) {
                                        handleButtonClick("submit");
                                      }
                                    }}
                                    className={`w-full md:w-auto ${
                                      data?.submitClassName ||
                                      "alterna-btn-primary"
                                    }`}
                                    disabled={isSubmitDisabled}
                                  >
                                    {submitLabel}
                                  </button>
                                )}

                                {/* Show Previous button if NOT first page */}
                                {!isFirstPage && !data?.hidePrevious && (
                                  <button
                                    onClick={() => handleButtonClick("back")}
                                    className={`w-full md:w-auto ${
                                      data?.previousClassName ||
                                      "alterna-btn-secondary"
                                    }`}
                                    disabled={
                                      showloader || data?.disablePrevious
                                    }
                                  >
                                    {previousLabel}
                                  </button>
                                )}

                               
                              </div>
                            );
                          };
                        } else {
                          // Default button for other themes
                          FormComponent = ({ data }) => (
                            <div className=" py-8 border-t border-gray-300 flex justify-center w-full">
                              <button
                                type="button"
                                onClick={() =>
                                  !showloader &&
                                  !isJourneyReadOnly &&
                                  isCurrentPageRequiredFieldsValid &&
                                  handleSubmit()
                                }
                                disabled={
                                  showloader ||
                                  isJourneyReadOnly ||
                                  !isCurrentPageRequiredFieldsValid
                                }
                                className={`${
                                  isJourneyReadOnly || !isCurrentPageRequiredFieldsValid
                                    ? "bg-gray-400 cursor-not-allowed text-gray-600"
                                    : "bg-green-500 hover:bg-green-600 active:scale-95 text-gray-800 cursor-pointer"
                                } px-10 py-2 rounded-md text-lg font-medium transition`}
                              >
                                {data?.label || "Submit"}
                              </button>
                            </div>
                          );
                        }
                        break;
                      default:
                        return null; // Unknown component type
                    }

                    // Handle special case for select component data
                    const itemData =
                      item.type === "select" &&
                      item.key ===
                        "patientDepartmentForSchedulerForSpecificForm"
                        ? {
                            ...item,
                            data: { values: allDepartmentsForSpecificForm },
                          }
                        : item.type === "radio" &&
                            item.key === "reasonForVisitForScheduler"
                          ? {
                              ...item,
                              values: allReasonsForSpecificForm,
                            }
                          : item;

                    if (FormComponent) {
                      const paddingMap = {
                        laptop: item?.customConditionPadding?.paddingLaptop || "ml-12",
                        tablet: item?.customConditionPadding?.paddingTablet || "ml-8",
                        mobile: item?.customConditionPadding?.paddingMobile || "ml-4"
                      };
                      const conditionalPadding = paddingMap[deviceType] || "ml-4";

                      const conditionalClass =
                        item.customConditionClass || "conditional-question";

                      const shouldRenderDescriptionsAboveButton =
                        answerDescriptionBlocks.length > 0 &&
                        item?.type === "button" &&
                        index === firstVisibleButtonIndex;

                      return (
                        <React.Fragment key={index}>
                          {shouldRenderDescriptionsAboveButton && (
                            <div className="form-width form-width-alterna mx-auto my-4">
                              <div className="w-full">
                                {answerDescriptionBlocks.map((descriptionBlock) => (
                                  <div
                                    key={descriptionBlock.id}
                                    className="my-3"
                                    dangerouslySetInnerHTML={{
                                      __html: descriptionBlock.html,
                                    }}
                                  />
                                ))}
                              </div>
                            </div>
                          )}
                          <div
                            className={`${
                              isConditional
                                ? `form-width form-width-alterna ${conditionalPadding} mx-auto flex justify-center ${conditionalClass} ${shouldShow ? "show" : ""}`
                                : "form-width form-width-alterna mx-auto flex justify-center my-3"
                            } ${isSelectBoxes && !isConditional ? "mb-5" : ""}`}
                          >
                            <FormComponent
                              data={specialProps.data || itemData}
                              setAnswer={setAnswer}
                              onChange={(value) => setAnswer(specialProps.data || itemData, { value: value })}
                              formClass={formClass}
                              formValidation={
                                specialProps.formValidation || formValid
                              }
                              {...specialProps}
                            />
                          </div>
                        </React.Fragment>
                      );
                    }

                    return null;
                  })}

                {/* Fallback: render descriptions at end when no button component exists on the page */}
                {answerDescriptionBlocks.length > 0 && firstVisibleButtonIndex === -1 && (
                  <div className="form-width form-width-alterna mx-auto my-4">
                    <div className="w-full">
                      {answerDescriptionBlocks.map((descriptionBlock) => (
                        <div
                          key={descriptionBlock.id}
                          className="my-3"
                          dangerouslySetInnerHTML={{
                            __html: descriptionBlock.html,
                          }}
                        />
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </>
        )}
        {openModal ? (
          <>
            <ModalBox
              openModal={true}
              title={modalTitle}
              SubTitle={modalSubtitle}
              hideClose={true}
              showButtons={false}
              showIcon={false}
              maxWidth={600}
            />
          </>
        ) : (
          <></>
        )}
      </div>
      {/* <div className="bottom-bar-shadow">
        <div className="flex justify-between pt-3 m-auto bottom-bar w-full">
          {firstPageFirstFormID === activeFormPageId ? (
            <div className="text-xs text-gray-600 max-w-[65%] content-center">
              By clicking Next/Submit, you agree to our{" "}
              <a
                href="https://dashboard-sandbox.healthblox.care/terms"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Terms of Service
              </a>{" "}
              and{" "}
              <a
                href="https://dashboard-sandbox.healthblox.care/privacy-policy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline"
              >
                Privacy Policy
              </a>
              .
            </div>
          ) : (
            <button
              onClick={() => !showloader && handleBack()}
              className="text_button"
            >
              Back
            </button>
          )}

          {formSchema &&
          formSchema[formSchema?.length - 1]?.id === activeFormPageId ? (
            <div
              onClick={() => !showloader && handleSubmit()}
              className="primary_button"
            >
              {isLastForm ? "Submit" : "Next"}
            </div>
          ) : (
            <div
              onClick={() => !showloader && handleNext()}
              className="primary_button"
            >
              Next
            </div>
          )}
        </div>
      </div> */}
    </div>
  );
};

export default FormRenderer;
